module.exports = __webpack_public_path__ + "media/components/assets/img/icons/bulb-orange-dc9cafdc7f6ba31be72d814652fa8ca3.svg";